var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout tw-flex tw-flex-col"},[_c('layout-header'),_c('div',{staticClass:"layout_main tw-flex-1 tw-flex"},[_c('layout-sidebar'),_c('div',{staticClass:"layout_content tw-flex-1"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }